// src/hooks/useAppInit/useAppInit.tsx
import { useEffect } from "react"
import { useAppDispatch } from "store"
import telegramAnalytics from "@telegram-apps/analytics"
import { loginWithTelegram, restoreSession } from "store/slices/authSlice"
import { isTelegramEnv } from "utils/tgWebApp"
import { initTelegramData } from "./utils/initTelegramData.ts"

export const useAppInit = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    initTelegramData()

    const initAuth = async () => {
      if (window.Telegram?.WebApp?.initData) {
        await dispatch(loginWithTelegram())
      } else {
        await dispatch(restoreSession())
      }
    }

    void initAuth()

    if (isTelegramEnv()) {
      setTimeout(async () => {
        try {
          await telegramAnalytics.init({
            token: import.meta.env.VITE_DC_TOKEN,
            appName: import.meta.env.VITE_DC_ANALYTICS_IDENTIFIER
          })
        } catch (error) {
          console.error(error)
        }
      })
    }
  }, [])
}
